import React, { useEffect, useState } from 'react';
import { Calendar, DatePicker, DateRangeType, defaultCalendarStrings } from '@fluentui/react';
import moment from 'moment';
import { Color } from '../../const/Const';
import { MessageConst, MessageConstEn } from '../../const/MessageConst';

const FieldMonth = (props) => {

    const [value, setValue] = useState();
    const [dKey, setDKey] = useState(1);

    useEffect(() => {
        let tValue = null;
        if (props.defaultValue) {
            let tPropsValue = null;
            if (props.defaultValue.length == 7) {
                tPropsValue = props.defaultValue;
            } else if (props.defaultValue.length > 7) {
                tPropsValue = props.defaultValue.substring(0, 7);
            }

            if (tPropsValue && moment(tPropsValue, "YYYY.MM").isValid()) {
                tValue = moment(tPropsValue, "YYYY.MM").toDate();
            }
        }
        setValue(tValue);
    }, [props.defaultValue]);


    const onChangeDate = (p_date) => {
        setDKey(r => r + 1);
        if (p_date) {
            props.onChanged(moment(p_date).format("YYYY.MM"), '', props.keyfield, '', props.title);
        } else {
            props.onChanged(null, '', props.keyfield, '', props.title);
        }
    }

    const onFormatDate = (date) => {
        return !date ? '' : moment(date).format("YYYY.MM");
    };

    let vColor = { fontWeight: 600 };
    if (props.gray) {
        vColor = {
            color: Color.graySecond,
            fontWeight: 400
        };
    }

    return (
        <div key={dKey}>
            <div style={{ display: 'flex' }}>
                <div style={{ fontSize: 14, ...vColor }}>{props.title}</div>{props.required && (<div style={{ color: Color.red }}>*</div>)}
            </div>
            <div style={{ marginTop: 6 }}>
                <DatePicker
                    formatDate={onFormatDate}
                    borderless={false}
                    value={value}
                    disabled={props.disable == true ? true : false}
                    calendarAs={() => (
                        <Calendar
                            dateRangeType={DateRangeType.Month}
                            showGoToToday
                            highlightSelectedMonth
                            isDayPickerVisible={false}
                            onSelectDate={onChangeDate}
                        />
                    )
                    }
                    placeholder={props.placeholder}
                />
                {(props.required && !value && props.checkreq) ? (
                    <div style={{ color: 'rgb(164, 38, 44)', fontSize: 12, fontWeight: 400, paddingTop: 5 }}>
                        {props.title + (props.lang == "en" ? MessageConstEn.fieldRequired : MessageConst.fieldRequired)}
                    </div>
                ) : null}
            </div>
        </div>
    );
}

export default FieldMonth;